<template>
  <div>
    <div class="height-300 d-flex flex-column justify-content-end">
      <vue-custom-scrollbar style="height: 100%">
        <div :class="$style.contentWrapper">
          <div :class="$style.message">
            <div :class="$style.messageContent">
              <div class="text-gray-4 font-size-12 text-uppercase">Vi, 5 min ranije</div>
              <div>Zdravo, potrebna mi je pomoć za kreiranje novog korisnika?</div>
            </div>
            <div :class="[$style.messageAvatar]" class="kit__utils__avatar">
              <img src="resources/images/avatars/avatar-2.png" alt="Milić P" />
            </div>
          </div>
          <div :class="[$style.message, $style.answer]">
            <div :class="$style.messageContent">
              <div class="text-gray-4 font-size-12 text-uppercase">Marko, 14 sec ranije</div>
              <div>Molim vas da nas pozovete na +382 69 019 123</div>
            </div>
            <div :class="[$style.messageAvatar]" class="kit__utils__avatar">
              <img src="resources/images/avatars/2.jpg" alt="Marko B" />
            </div>
          </div>
        </div>
      </vue-custom-scrollbar>
    </div>
    <div class="pt-2 pb-2"></div>
    <form action>
      <div class="input-group mb-3">
        <input
          type="text"
          class="form-control"
          placeholder="Pošalji..."
          aria-label="Recipient's username"
          aria-describedby="button-addon2"
        />
        <div class="input-group-append">
          <button class="btn btn-primary" type="button">
            <i class="fe fe-send align-middle" />
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
export default {
  name: 'KitGeneral14',
  components: { vueCustomScrollbar },
}
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
